import CurrierBase from "./CurrierBase";
import MessengerHub from "./MessengerHub";

export class ChannelHandler {
  protected subscribers;
  protected messengerHub: MessengerHub;
  protected currentIndex;
  protected awaitingResponse = {};

  constructor() {
    this.messengerHub = null;

    this.subscribers = new Object();
    this.currentIndex = 1;
  }

  onRegister(messengerHub) {
    this.messengerHub = messengerHub;
  }

  // returns a function to unsubscribe
  onSubscribe(channelName: string, onMessage) {
    // if no one has subscribed yet then hook them up
    if (!this.subscribers[channelName]) {
      this.subscribers[channelName] = new Object();
    }

    // add the subscribed item for unsubscribing
    const subscribers = this.subscribers[channelName];
    const subscriberIndex = this.currentIndex++;
    subscribers[subscriberIndex] = onMessage;

    const unsub = () => {
      delete subscribers[subscriberIndex];
    };

    return unsub;
  }

  handlesChannel(channelName) {
    return false;
  }

  // =================================
  //          MESSAGE PACKAGING
  // =================================

  // packages up a message right before its sent across a currier
  packageMessage(
    channelName: string,
    rawMessage: string,
    currier: CurrierBase,
    responseKey = null,
    responseTo = null
  ) {
    return {
      channel: channelName,
      message: rawMessage,
      responseKey,
      responseTo,
    }; // eventually this could be a class but its probably ideal for it to remain as simple as possible
  }

  // this should return an object as with a channel and a message
  unpackMessage(packagedMessage) {
    return packagedMessage;
  }

  getResponseKey(rawMessage) {
    return new Date().getTime();
  }

  // message is being sent out into the system
  sendMessage(
    channelName: string,
    rawMessage,
    curriers = null,
    onResponse = null
  ) {
    // if we dont receive a list of curriers, take it from the sms
    if (!curriers && this.messengerHub) {
      curriers = this.messengerHub.getCurriers();
    }

    // if they expect a response then we need to look for it
    let responseKey = this.getResponseKey(rawMessage);

    // now loop through
    Object.keys(curriers).forEach((key) => {
      const currier = curriers[key];
      // filter out unwanted curriers
      if (!this.shouldSendWithCurrier(channelName, rawMessage, currier)) return;

      // this wraps the various message details into a single object
      const message = this.packageMessage(
        channelName,
        rawMessage,
        currier,
        responseKey
      );

      if (onResponse) {
        this.awaitingResponse[responseKey] = { onResponse, currier };
      }

      currier.sendMessage(message);
    });
  }

  //hook for filtering channels
  // since this is the default handler it always returns true
  shouldSendWithCurrier(channel, rawMessage, currier) {
    return true;
  }

  onMessageReceived(packagedMessage, currier) {
    //lets separate this puppy out
    const unpacked = this.unpackMessage(packagedMessage);

    // if we get a null response then we abort
    if (unpacked == null) return;

    const {
      channel,
      message,
      responseKey,
      responseTo,
    }: { channel: string; message: any; responseKey: any; responseTo: any } =
      unpacked;

    // console.log(
    //   "unpacked in on message receieved",
    //   unpacked,
    //   this.awaitingResponse,
    //   this.awaitingResponse[responseTo]
    // );

    // if this is a direct response, only activate the callback
    if (responseTo && this.awaitingResponse[responseTo]) {
      this.awaitingResponse[responseTo].onResponse(message);

      // otherwise, send it out across the channel
    } else if (!responseTo) {
      // distribute to all subscribers
      if (this.subscribers[channel]) {
        Object.keys(this.subscribers[channel]).forEach((key) => {
          const response = this.subscribers[channel][key](message);

          // console.log(
          //   "response, responsekey, responseto",
          //   response,
          //   responseKey,
          //   responseTo
          // );
          if (response && responseKey) {
            currier.sendMessage(
              this.packageMessage(
                channel,
                response,
                currier,
                this.getResponseKey(response),
                responseKey
              )
            );
          }
        });
      }
    }
  }
}

export default ChannelHandler;
